import './index_mWeb.css';
import I18n from '../../../utilities/locale';
import CreateTeamPlayerRowFootballMWeb from '../create_team_player_row_football/index_mWeb';
import { View, Text, FlatListWrapper } from '../../../component';
import FlatList from 'flatlist-react';
import { Key } from 'react';
import TeamSortingFootball from '../team_sorting_football';
import React from 'react';

interface Props {
  data: any;
  matchItem: any;
  onPressPlayer: any;
  selectedTab?: number;
  renderWhenEmpty: any;
  keeperList: any;
  defenderList: any;
  midfielderList: any;
  forwardList: any;
  lineupsOut?: boolean;
  keeperListDisable?: boolean;
  defenderListDisable?: boolean;
  midfielderListDisable?: boolean;
  forwardListDisable?: boolean;
  teamAPlayersCount?: number;
  teamBPlayersCount?: number;
  totalCreditCount?: number;
  substitutePlayers: any;
  sortName?: string;
  sortType?: string;
  onUpdateSortingList?: any;
}

const CreateTeamTabContentFootballMWeb = ({
  data,
  matchItem,
  onPressPlayer,
  selectedTab,
  renderWhenEmpty,
  keeperList,
  midfielderList,
  defenderList,
  forwardList,
  lineupsOut,
  keeperListDisable,
  defenderListDisable,
  midfielderListDisable,
  forwardListDisable,
  teamAPlayersCount,
  teamBPlayersCount,
  totalCreditCount,
  substitutePlayers,
  sortName,
  sortType,
  onUpdateSortingList
}: Props) => {
  const renderItemPlayer = (item: { id: Key | null | undefined }) => (
    <CreateTeamPlayerRowFootballMWeb
      matchItem={matchItem}
      item={item}
      key={item.id}
      onPressPlayer={onPressPlayer}
      lineupsOut={lineupsOut}
      keeperListDisable={keeperListDisable}
      defenderListDisable={defenderListDisable}
      midfielderListDisable={midfielderListDisable}
      forwardListDisable={forwardListDisable}
      teamAPlayersCount={teamAPlayersCount}
      teamBPlayersCount={teamBPlayersCount}
      totalCreditCount={totalCreditCount}
      substitutePlayers={substitutePlayers}
    />
  );

  const pick1 = {
    color: '#F5F5F5'
  };

  const pickLabel =
    selectedTab === 0
      ? I18n.t('PickGoalKeeper')
      : selectedTab === 1
      ? I18n.t('PickDefender')
      : selectedTab === 2
      ? I18n.t('PickMidfielder')
      : I18n.t('PickForward');

  const pickLabelMessage =
    selectedTab === 0
      ? I18n.t('PickGoalKeeperMaxMessage')
      : selectedTab === 1
      ? I18n.t('PickDefenderMaxMessage')
      : selectedTab === 2
      ? I18n.t('PickDefenderMaxMessage')
      : I18n.t('PickForwardMaxMessage');
  return (
    <View className={'create-team-tab-content-wrapper_mWeb'}>
      <View className={'create-team-tab-content-pick-player-wrapper_mWeb'}>
        <Text className={'create-team-tab-content-pick-label_mWeb'} style={pick1}>
          {`${pickLabel}`}
        </Text>
        <Text className={'create-team-tab-content-pick-message_mWeb'} style={pick1}>
          &nbsp;&nbsp;-&nbsp;&nbsp;{pickLabelMessage}
        </Text>
      </View>

      <View className={'create-team-tab-content-sorting-header_mWeb'}>
        <TeamSortingFootball
          keeperList={keeperList}
          defenderList={defenderList}
          midfielderList={midfielderList}
          forwardList={forwardList}
          sortName={sortName}
          sortType={sortType}
          onUpdateSortingList={onUpdateSortingList}
        />
      </View>

      <View className={'create-team-tab-content-flatlist_mWeb'}>
        <div className={'flat-list-outer'}>
          <FlatListWrapper className={'flat-list-padding'}>
            <FlatList
              list={data}
              renderItem={renderItemPlayer}
              renderOnScroll
              renderWhenEmpty={renderWhenEmpty}
            />
          </FlatListWrapper>
        </div>
      </View>
    </View>
  );
};
CreateTeamTabContentFootballMWeb.defaultProps = {
  selectedTeamPlayers: [],
  isEdit: false,
  substitutePlayers: []
};
export default React.memo(CreateTeamTabContentFootballMWeb);
